import parse, { Element, HTMLReactParserOptions } from "html-react-parser";
import { FormEbook } from "../components/Article/FormEbook";
import { Newsletter } from "../components/Newsletter";
import AdBanner from "../components/AdsBanner";
interface DomNodeData extends Element {
  attribs: { id: string };
  data: string;
  type: Element["type"] & "text";
}
function snippetParameterParse(parameters: string) {
  return Object.fromEntries(
    new URLSearchParams(parameters.replace(/\b \b/gi, "&"))
  );
}
export const parseContentPost = (
  content: string,
  indexAdsenseId: string,
  contentAdsenseId: string
) => {
  let index = 0;
  let firstH2 = true;

  return parse(content, {
    replace: (domNode: DomNodeData) => {
      if (domNode.type === "text") {
        const snippetRegex = /{{(\D*?)(\s(?<parameters>.*?))?}}/;
        const snippet = domNode.data.match(snippetRegex);

        if (snippet) {
          index++;
          const componentName = snippet[1];
          const props = snippet.groups.parameters
            ? snippetParameterParse(snippet.groups.parameters)
            : undefined;

          switch (componentName) {
            case "ebook-subscription":
              return (
                <FormEbook postId={props.postId} key={index + props.postId} />
              );
            case "newsletter-subscription":
              return <Newsletter key={index} />;
            default:
              break;
          }
        }
      }
    },
    transform: (reactNode, domNode: DomNodeData) => {
      if (domNode.attribs && domNode.attribs.id === "ez-toc-container") {
        index++;
        return (
          <div className="index-adsense-wrapper" key={index + indexAdsenseId}>
            {reactNode}
            {indexAdsenseId && (
              <AdBanner
                data-ad-format="auto"
                data-ad-slot={indexAdsenseId}
                data-full-width-responsive="true"
              />
            )}
          </div>
        );
      } else if (
        domNode.type === "tag" &&
        domNode.tagName === "h2" &&
        firstH2
      ) {
        firstH2 = false;
        index++;
        return (
          <>
            {contentAdsenseId && (
              <AdBanner
                key={index + contentAdsenseId}
                customclass="contentAdBanner"
                data-ad-format="auto"
                data-ad-slot={contentAdsenseId}
                data-full-width-responsive="true"
              />
            )}
            {reactNode}
          </>
        );
      } else {
        return reactNode;
      }
    },
  } as HTMLReactParserOptions);
};
